import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-logistic-kpi',
  templateUrl: './logistic-kpi.component.html',
  styleUrls: ['./logistic-kpi.component.css']
})
export class LogisticKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi7: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  LogisticKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi6: boolean = false;
  manfMonthFilterKpi6: monthFilter;

  Highcharts = Highcharts;

  totalDataLOG: any;
  totalDataKpiChartOptionsLOG: Highcharts.Options;
  panelWiseDataLOG: any;
  panelWiseKpiChartOptionsLOG: Highcharts.Options;

  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-7', this.isManfMonthFilterSelectedKpi6 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi6) {
      this._dataService.setCookie('s-manfmonth-val-kpi-7', this.manfMonthFilterKpi6.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-7');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi6 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-7');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi6 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi6 == null) {
      this.manfMonthFilterKpi6 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi7 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi6 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi6 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpLogisticKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyLOG: number = 0;
    let _delayQtyLOG: number = 0;
    let _onTimeQtyLOG: number = 0;
    let _delayQtyLOGZS1: number = 0;
    let _onTimeQtyLOGZS1: number = 0;
    let _delayQtyLOGZS1DBB: number = 0;
    let _onTimeQtyLOGZS1DBB: number = 0;
    let _delayQtyLOGZS2: number = 0;
    let _onTimeQtyLOGZS2: number = 0;
    let _delayQtyLOGZS9: number = 0;
    let _onTimeQtyLOGZS9: number = 0;
    let _delayQtyLOGZN1: number = 0;
    let _onTimeQtyLOGZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi7.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi7[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for Dispatch planned and Actual Dates      

            if (_tmpSSO.logisticIP.lastDeliveryActualDate != null) {
              let _dispatchActual = _tmpSSO.logisticIP.lastDeliveryActualDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _dispatchOtherDate;
              if( _tmpSSO.logisticIP.dispatchFromPlantRequestDate==null){
                _isRequested = false;
                _dispatchOtherDate = _tmpSSO.logisticIP.dispatchFromPlantPlannedDate.getTime();
                _isRevised = _tmpSSO.logisticIP.dispatchFromPlantPlannedDateIsRevised;
            }
            else{
              _isRequested = true;
              _dispatchOtherDate = _tmpSSO.logisticIP.dispatchFromPlantRequestDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyLOG += temp;
                  
                  
                }
              }
            });
              let _dispatchDiff_time =  _dispatchOtherDate - _dispatchActual;
              let _dispatchDiff = _dispatchDiff_time / (1000 * 3600 * 24);
              /// Dispatch Finalization Delay
              if (_dispatchDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyLOG += temp;
                    }
                  }
                });

                let _individualDelayQtyLog = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyLOGZS1 += temp;
                          _individualDelayQtyLog += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyLOGZS1DBB += temp;
                          _individualDelayQtyLog += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyLOGZS2 += temp;
                          _individualDelayQtyLog += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyLOGZN1 += temp;
                          _individualDelayQtyLog += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyLOGZS9 += temp;
                          _individualDelayQtyLog += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.logisticIP.dispatchFromPlantPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.logisticIP.dispatchFromPlantPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.logisticIP.dispatchFromPlantRequestDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Dispatch', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyLog, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.logisticIP.lastDeliveryActualDate, _dispatchDiff, _tmpSSO.logisticIP.lastDeliveryActualDateReason)
                
                _tmpLogisticKpi.push(_tmpSSOobj);
              }
              // Dispatch Finalization on Time
              if (_dispatchDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyLOG += temp;
                    }
                  }
                });

                let _individualOnTimeQtyLog = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyLOGZS1 += temp;
                          _individualOnTimeQtyLog += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyLOGZS1DBB += temp;
                          _individualOnTimeQtyLog += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyLOGZS2 += temp;
                          _individualOnTimeQtyLog += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyLOGZN1 += temp;
                          _individualOnTimeQtyLog += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyLOGZS9 += temp;
                          _individualOnTimeQtyLog += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.logisticIP.dispatchFromPlantPlannedDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.logisticIP.dispatchFromPlantPlannedDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.logisticIP.dispatchFromPlantRequestDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Dispatch', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyLog, _plannedTmp, _revisedTmp,
                _requestedTmp, _tmpSSO.logisticIP.lastDeliveryActualDate, _dispatchDiff, _tmpSSO.logisticIP.lastDeliveryActualDateReason)

                  _tmpLogisticKpi.push(_tmpSSOobj);
              }     


            }
          });

        }


      }

    }

    if (_totalQtyLOG != 0 || _onTimeQtyLOG != 0 || _delayQtyLOG != 0) {
      this.totalDataLOG = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyLOG,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyLOG,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyLOG,
        }]
      }

      ];
    }
    else { this.totalDataLOG = null; }

    this.totalDataKpiChartOptionsLOG = this._kpiCharServ.getTotalDataChartOptions(this.totalDataLOG);

    if (_onTimeQtyLOGZN1 != 0 || _onTimeQtyLOGZS9 != 0 || _onTimeQtyLOGZS1 != 0 || _onTimeQtyLOGZS1DBB != 0 || _onTimeQtyLOGZS2 != 0
      || _delayQtyLOGZN1 != 0 || _delayQtyLOGZS9 != 0 || _delayQtyLOGZS1 != 0 || _delayQtyLOGZS1DBB != 0 || _delayQtyLOGZS2 != 0) {

      this.panelWiseDataLOG = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyLOGZN1, _onTimeQtyLOGZS9, _onTimeQtyLOGZS1, _onTimeQtyLOGZS1DBB, _onTimeQtyLOGZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyLOGZN1, _delayQtyLOGZS9, _delayQtyLOGZS1, _delayQtyLOGZS1DBB, _delayQtyLOGZS2],
      }

      ];
    }
    else { this.panelWiseDataLOG = null; }

    this.panelWiseKpiChartOptionsLOG = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataLOG);

    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.LogisticKpi = _tmpLogisticKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi6 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi6) {
      return this.manfMonthFilterKpi6.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi6) {
      return this.manfMonthFilterKpi6.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi6.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi6.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi6.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi6.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi6 == true && this.manfMonthFilterKpi6 != null) {
      if (this.manfMonthFilterKpi6.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }
}
